import React, { createContext, useContext } from "react";
import type {
  ReactNode,
  ComponentType,
  AnchorHTMLAttributes,
  RefAttributes,
} from "react";
import type { TLang } from "@litres-libs/types";

export type TDefaultLink = AnchorHTMLAttributes<HTMLAnchorElement> &
  RefAttributes<HTMLAnchorElement> & {
    e2eId?: string;
    children?: ReactNode;
    className?: string;
    href?: string;
  };

interface IUIKitContext {
  lang: TLang;
  linkComponent?: ComponentType<TDefaultLink>;
}
interface IUIKitProvider extends IUIKitContext {
  children: ReactNode;
}
const UIKitContext = createContext<IUIKitContext>({
  lang: "ru-RU",
});
export const useUIKitContext = () => useContext(UIKitContext);
export const UIKitProvider = ({
  lang,
  linkComponent,
  children,
}: IUIKitProvider) => (
  <UIKitContext.Provider value={{ lang, linkComponent }}>
    {children}
  </UIKitContext.Provider>
);
